import { IQualityReport } from '@travelnest/typewriter';

import { idOrLegacyId } from '../../entities/properties/selectors';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';

export const getByPropertyIdActions = createActionCreators<
	{ T: 'QUALITY_GET_BY_PROPERTY_ID_REQUEST', P: { id: string, channel: string } },
	{ T: 'QUALITY_GET_BY_PROPERTY_ID_RECEIVE', P: { quality: IQualityReport } },
	{ T: 'QUALITY_GET_BY_PROPERTY_ID_FAILURE', P: { id: string, channel: string, error: Error } }
	>('QUALITY_GET_BY_PROPERTY_ID_REQUEST', 'QUALITY_GET_BY_PROPERTY_ID_RECEIVE', 'QUALITY_GET_BY_PROPERTY_ID_FAILURE');

export const getQualityByPropertyIdAndChannel = (id: string | number, channel: string): ThunkAction =>
		async (dispatch, getState, { _deprecatedApi: api }) => {
	const propertyId = idOrLegacyId(id);
	dispatch(getByPropertyIdActions.QUALITY_GET_BY_PROPERTY_ID_REQUEST({ id: propertyId, channel }));
	try {
		const quality = await api.quality.getByPropertyIdAndChannel(propertyId, channel);
		dispatch(getByPropertyIdActions.QUALITY_GET_BY_PROPERTY_ID_RECEIVE({ quality }));
	} catch (error) {
		dispatch(getByPropertyIdActions.QUALITY_GET_BY_PROPERTY_ID_FAILURE({ id: propertyId, channel, error }));
		throw error;
	}
};

const actions = {
	...getByPropertyIdActions
};

type QualityActions = ActionValues<typeof actions>;
type QualityActionTypes = ActionTypeNames<QualityActions>;
export type Actions = QualityActions[keyof QualityActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as QualityActionTypes);
